// JavaScript Document
/* Modernizr 2.8.1 (Custom Build) | MIT & BSD
 * Build: http://modernizr.com/download/#-csstransitions-cssclasses-testprop-testallprops-domprefixes-load
 */
window.Modernizr=function(a,b,c){function x(a){j.cssText=a}function y(a,b){return x(prefixes.join(a+";")+(b||""))}function z(a,b){return typeof a===b}function A(a,b){return!!~(""+a).indexOf(b)}function B(a,b){for(var d in a){var e=a[d];if(!A(e,"-")&&j[e]!==c)return b=="pfx"?e:!0}return!1}function C(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:z(f,"function")?f.bind(d||b):f}return!1}function D(a,b,c){var d=a.charAt(0).toUpperCase()+a.slice(1),e=(a+" "+n.join(d+" ")+d).split(" ");return z(b,"string")||z(b,"undefined")?B(e,b):(e=(a+" "+o.join(d+" ")+d).split(" "),C(e,b,c))}var d="2.8.0",e={},f=!0,g=b.documentElement,h="modernizr",i=b.createElement(h),j=i.style,k,l={}.toString,m="Webkit Moz O ms",n=m.split(" "),o=m.toLowerCase().split(" "),p={},q={},r={},s=[],t=s.slice,u,v={}.hasOwnProperty,w;!z(v,"undefined")&&!z(v.call,"undefined")?w=function(a,b){return v.call(a,b)}:w=function(a,b){return b in a&&z(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=t.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(t.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(t.call(arguments)))};return e}),p.csstransitions=function(){return D("transition")};for(var E in p)w(p,E)&&(u=E.toLowerCase(),e[u]=p[E](),s.push((e[u]?"":"no-")+u));return e.addTest=function(a,b){if(typeof a=="object")for(var d in a)w(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof f!="undefined"&&f&&(g.className+=" "+(b?"":"no-")+a),e[a]=b}return e},x(""),i=k=null,e._version=d,e._domPrefixes=o,e._cssomPrefixes=n,e.testProp=function(a){return B([a])},e.testAllProps=D,g.className=g.className.replace(/(^|\s)no-js(\s|$)/,"$1$2")+(f?" js "+s.join(" "):""),e}(this,this.document),function(a,b,c){function d(a){return"[object Function]"==o.call(a)}function e(a){return"string"==typeof a}function f(){}function g(a){return!a||"loaded"==a||"complete"==a||"uninitialized"==a}function h(){var a=p.shift();q=1,a?a.t?m(function(){("c"==a.t?B.injectCss:B.injectJs)(a.s,0,a.a,a.x,a.e,1)},0):(a(),h()):q=0}function i(a,c,d,e,f,i,j){function k(b){if(!o&&g(l.readyState)&&(u.r=o=1,!q&&h(),l.onload=l.onreadystatechange=null,b)){"img"!=a&&m(function(){t.removeChild(l)},50);for(var d in y[c])y[c].hasOwnProperty(d)&&y[c][d].onload()}}var j=j||B.errorTimeout,l=b.createElement(a),o=0,r=0,u={t:d,s:c,e:f,a:i,x:j};1===y[c]&&(r=1,y[c]=[]),"object"==a?l.data=c:(l.src=c,l.type=a),l.width=l.height="0",l.onerror=l.onload=l.onreadystatechange=function(){k.call(this,r)},p.splice(e,0,u),"img"!=a&&(r||2===y[c]?(t.insertBefore(l,s?null:n),m(k,j)):y[c].push(l))}function j(a,b,c,d,f){return q=0,b=b||"j",e(a)?i("c"==b?v:u,a,b,this.i++,c,d,f):(p.splice(this.i++,0,a),1==p.length&&h()),this}function k(){var a=B;return a.loader={load:j,i:0},a}var l=b.documentElement,m=a.setTimeout,n=b.getElementsByTagName("script")[0],o={}.toString,p=[],q=0,r="MozAppearance"in l.style,s=r&&!!b.createRange().compareNode,t=s?l:n.parentNode,l=a.opera&&"[object Opera]"==o.call(a.opera),l=!!b.attachEvent&&!l,u=r?"object":l?"script":"img",v=l?"script":u,w=Array.isArray||function(a){return"[object Array]"==o.call(a)},x=[],y={},z={timeout:function(a,b){return b.length&&(a.timeout=b[0]),a}},A,B;B=function(a){function b(a){var a=a.split("!"),b=x.length,c=a.pop(),d=a.length,c={url:c,origUrl:c,prefixes:a},e,f,g;for(f=0;f<d;f++)g=a[f].split("="),(e=z[g.shift()])&&(c=e(c,g));for(f=0;f<b;f++)c=x[f](c);return c}function g(a,e,f,g,h){var i=b(a),j=i.autoCallback;i.url.split(".").pop().split("?").shift(),i.bypass||(e&&(e=d(e)?e:e[a]||e[g]||e[a.split("/").pop().split("?")[0]]),i.instead?i.instead(a,e,f,g,h):(y[i.url]?i.noexec=!0:y[i.url]=1,f.load(i.url,i.forceCSS||!i.forceJS&&"css"==i.url.split(".").pop().split("?").shift()?"c":c,i.noexec,i.attrs,i.timeout),(d(e)||d(j))&&f.load(function(){k(),e&&e(i.origUrl,h,g),j&&j(i.origUrl,h,g),y[i.url]=2})))}function h(a,b){function c(a,c){if(a){if(e(a))c||(j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}),g(a,j,b,0,h);else if(Object(a)===a)for(n in m=function(){var b=0,c;for(c in a)a.hasOwnProperty(c)&&b++;return b}(),a)a.hasOwnProperty(n)&&(!c&&!--m&&(d(j)?j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}:j[n]=function(a){return function(){var b=[].slice.call(arguments);a&&a.apply(this,b),l()}}(k[n])),g(a[n],j,b,n,h))}else!c&&l()}var h=!!a.test,i=a.load||a.both,j=a.callback||f,k=j,l=a.complete||f,m,n;c(h?a.yep:a.nope,!!i),i&&c(i)}var i,j,l=this.yepnope.loader;if(e(a))g(a,0,l,0);else if(w(a))for(i=0;i<a.length;i++)j=a[i],e(j)?g(j,0,l,0):w(j)?B(j):Object(j)===j&&h(j,l);else Object(a)===a&&h(a,l)},B.addPrefix=function(a,b){z[a]=b},B.addFilter=function(a){x.push(a)},B.errorTimeout=1e4,null==b.readyState&&b.addEventListener&&(b.readyState="loading",b.addEventListener("DOMContentLoaded",A=function(){b.removeEventListener("DOMContentLoaded",A,0),b.readyState="complete"},0)),a.yepnope=k(),a.yepnope.executeStack=h,a.yepnope.injectJs=function(a,c,d,e,i,j){var k=b.createElement("script"),l,o,e=e||B.errorTimeout;k.src=a;for(o in d)k.setAttribute(o,d[o]);c=j?h:c||f,k.onreadystatechange=k.onload=function(){!l&&g(k.readyState)&&(l=1,c(),k.onload=k.onreadystatechange=null)},m(function(){l||(l=1,c(1))},e),i?k.onload():n.parentNode.insertBefore(k,n)},a.yepnope.injectCss=function(a,c,d,e,g,i){var e=b.createElement("link"),j,c=i?h:c||f;e.href=a,e.rel="stylesheet",e.type="text/css";for(j in d)e.setAttribute(j,d[j]);g||(n.parentNode.insertBefore(e,n),m(c,0))}}(this,document),Modernizr.load=function(){yepnope.apply(window,[].slice.call(arguments,0))};

// General Igloo JS document

var Igloo = {init:function() {

	this.log = function (a, b, c, d) {

		//console.log(arguments.callee.caller)
		if (window.console){
			var l = arguments.length;
			if(l == 4) window.console.log(a, b, c, d);
			if(l == 3) window.console.log(a, b, c);
			if(l == 2) window.console.log(a, b);
			if(l == 1) window.console.log(a);
		}

	}
	this.logStatic = function (a) {
		if (window.console) window.console.log(JSON.parse(JSON.stringify(a)));
	}
	this.warn = function () {
		return this.log(Array.prototype.slice.call(arguments));
	}
	this.alertR = function (a){
		for (var i in a) if (a.hasOwnProperty(i)) alert(i + ": " + a[i])
	}
	
	//Array functions
	this.isArray = function(arr){
		return Object.prototype.toString.call( arr ) === '[object Array]';
	}
	this.isIn = function(arr,name,value){
		for(var i in arr) {
			if(Igloo.defined(value)){
				if(arr[i][name] === value) return i;
			}else{
				if(arr[i] === name) return i;
			}
		}
		return false;
	}

	this.searchArray = function(arr,name,value,multi){
		var r = [];

		for(var i in arr) {
			var v, found = false;
			if(Igloo.defined(value)){
				if(arr[i][name] === value){
					v = arr[i];
					found = true;
				}
			}else{
				if(arr[i] === name){
					v = arr[i];
					found = true;
				}
			}
			if(found){
				if(multi)  	r.push(v);
				else 		return v;
			}

		}
		return multi ? r : false;
	}
	this.searchArrayWeak = function(arr,name,value,multi){
		var r = [];

		for(var i in arr) {
			var v, found = false;
			if(Igloo.defined(value)){
				if(arr[i][name] == value){
					v = arr[i];
					found = true;
				}
			}else{
				if(arr[i] == name){
					v = arr[i];
					found = true;
				}
			}
			if(found){
				if(multi)  	r.push(v);
				else 		return v;
			}

		}
		return multi ? r : false;
	}
	this.matchArray = function(arr, key, regex){
		if(!Igloo.defined(regex)){
			regex = key;
			key = false;
		}	
		for (var i = 0; i < arr.length; i++) {
			var a = key ? arr[i][key] : arr[i];
			if (a.match(regex)){
				return i;
			}
		}
		return false;
	}
	this.compareObjectsBasic = function(object1, object2) { //Need to have keys in the same order.
		return JSON.stringify(object1) === JSON.stringify(object2)
	}
	this.append = function(a,b){
		var c = [];
		for (var i = 0, mx = a.length; i < mx; i++) c.push(a[i]);
		for (var i = 0, mx = b.length; i < mx; i++) c.push(b[i]);
		return c;
	}
	
	this.copy = function(a){
		return this.merge({},a);
	}

	this.clone1 = function(object, deep){ //Deep copy, requires jquery
		if(typeof(deep) == "undefined") deep = true;
		if(deep) 	return $.extend(true, {}, object);
		else		return $.extend({}, object);
	}

	this.isArray = function(a){
		return '' + a !== a && {}.toString.call(a) == '[object Array]';
	}
	this.clone = function (object,deep) {

		if(typeof(deep) == "undefined") deep = true;

		if(Igloo.isArray(object)){
			var newObject = [];
			for(var i = 0; i < object.length; i++){
				newObject.push(deep ? this.clone(object[i]) : object[i]);
			}
			return newObject;
		}else if(Object.prototype.toString.call(object) === '[object Object]' ){
			var newObject = {};
			for ( var prop in object ) newObject[prop] = deep ? this.clone(object[prop]) : object[prop];
			return newObject;
		}else{
			return object
		}
	};

    // Object functions

    this.where = function (arr, objKey, objValue) {
        var list = [];
        for (var i = 0, ii = arr.length; i < ii; i += 1) {
            if (arr[i].hasOwnProperty(objKey) && arr[i][objKey] === objValue) {
                list.push(arr[i]);
            }
        }
        return list;
    }
	
	//V001, 07/12/11, iid
	this.merge = function(a,b){
		if(typeof(a) != "object") a = {};
		if(typeof(b) != "object") b = {};
		var c = {};
		for(var i in a){
			if(a.hasOwnProperty(i))	c[i] = a[i];
		}		
		for(var i in b){
			if(b.hasOwnProperty(i))	c[i] = b[i];
		}
		return c;
	}

	this.isEmpty = function(object){ //Requires Jquery
		return typeof(object) == "object" && $.isEmptyObject(object)
	}
	
	
	//Variable functions
	this.defined = function(v){
		if(!v && v !== 0 && v !== false && v !== "") return false;
		return true;
	}
	this.isDefined = this.defined;
	
	this.isFunc = function(f){
		return ((f) && typeof f == 'function');
	}


	//Regex

	this.escapeRegEx = function(str) {
		return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	}

	//DELEGATION
	
	//V1-01 - corrected scope mistake in f.apply(t,b);
	//V1-02 - made delegate first the default
	this.delegate_last = function(){
		var t = arguments[0];				
		var f = arguments[1];
		var a = [];		
		for(var i = 2; i < arguments.length; i++) a.push(arguments[i]);
		return function(){var b = Igloo.append(arguments,a);return f.apply(t,b);}
	}
	
	this.delegate_first = function(){
		var t = arguments[0];				
		var f = arguments[1];
		
		//multiple delegate
		if(!Igloo.defined(f) && typeof(t) == "object") return function(){ for(var i in t) if(t[i] && typeof(t[i]) == "object") Igloo.delegate_first.apply(Igloo,t[i])(); }
		
		//Single
		var a = [];		
		for(var i = 2; i < arguments.length; i++) a.push(arguments[i]);
		return function(){var b = Igloo.append(a,arguments); if(!f){ Igloo.log("Delegate failed"); return function(){}; }else return f.apply(t?t:this,b);}
	}	
	
	this.delegate = this.delegate_first;
	
	this.delegate_none = function(){
		var a = [];
		var t = arguments[0];				
		var f = arguments[1];
		for(var i = 2; i < arguments.length; i++) a.push(arguments[i]);
		return function(){f.apply(t,a);}
	}

	this.delegateOnce = function(){
		var a = [];
		var t = arguments[0];
		var f = arguments[1];
		for(var i = 2; i < arguments.length; i++) a.push(arguments[i]);
		var complete = false;
		return function(){if(complete) return; f.apply(t,a); complete = true;}
	}
	
	this.$delegate = function(){
		var t = arguments[0];				
		var f = arguments[1];
		
		//multiple delegate
		if(!Igloo.defined(f) && typeof(t) == "object") return function(){ for(var i in t) if(t[i] && typeof(t[i]) == "object") Igloo.$delegate.apply(Igloo,t[i])(); }
		
		//Single
		var a = [];
		for(var i = 2; i < arguments.length; i++) a.push(arguments[i]);
		return function(){ var b = Igloo.append(Igloo.append([$(this)],a),arguments); if(!f){ Igloo.log("Delegate failed"); return function(){}; }else return f.apply(t,b);}
	}

	this.$d = function(){

		var t = arguments[0];
		var f = arguments[1];

		//multiple delegate
		if(!Igloo.defined(f) && typeof(t) == "object") return function(){ for(var i in t) if(t[i] && typeof(t[i]) == "object") Igloo.$delegate.apply(Igloo,t[i])(); }

		//Single
		var a = [];

		for(var i = 2; i < arguments.length; i++) a.push(arguments[i]);

		return function(e){if(e.preventDefault) e.preventDefault(); var b = Igloo.append(Igloo.append([$(this)],a),arguments); if(!f){ Igloo.log("Delegate failed"); return function(){}; }else return f.apply(t,b);}
	}

	this.ff = function(f){ //Force Function
		return typeof(f) == "function" ? f : function(){};
	}
	
	this.throttle = function(fn, threshhold, scope) {
		threshhold || (threshhold = 250);
		var last, deferTimer;
		return function () {
			var context = scope || this;
			;
			var now = +new Date,
			args = arguments;

			if (last && now < last + threshhold) {

				// hold on to it
				clearTimeout(deferTimer);
				deferTimer = setTimeout(function () {
					last = now;
					fn.apply(context, args);
				}, threshhold);
			} else {
				last = now;
				fn.apply(context, args);
			}
		};
	}

	/**
	 Returns an object that allows processes to queue up. Add them with object.add(function)

	 @param threshold The time in ms to delay between queued items
	 @return A throttleQueue object, with public add(function) and clear() methods.
	 */
	this.throttleQueue = function(threshold) {

		var timeout 	= 0,
			queue		= [],
			last		= 0,
			_this		= this;

		this.add = function(fn){
			queue.push(fn);
			check();
		}
		this.clear = function(clearLast){
			if(!Igloo.defined(clearLast)) clearLast = true;
			clearTimeout(timeout);
			timeout = 0;
			queue 	= [];
			if(clearLast) last = 0;
		}
		var check = function(){
			var now 	= +new Date;

			if(!queue.length) return false;

			var diff = now - last;
			if(!last || diff > threshold){
				queue[0]();
				queue.splice(0,1);
				last = now;
				check();
			}else if(!timeout){
				var t = threshold-diff+1;
				timeout = setTimeout(function(){
					timeout = 0;
					check();
				},t);
			}
		}

	}
	this.throttleQueueFactory = function(threshold){
		return new Igloo.throttleQueue(threshold);
	}

	this.debounce = function(fn, threshhold, scope, immediate) {

		var timeout;
		var f = function() {
			var context = scope?scope:this, args = arguments;
			var later = function() {
				timeout = null;
				f.waiting = false;
				if (!immediate) fn.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, threshhold);
			f.waiting = true;
			if (callNow) fn.apply(context, args);
		};
		f.waiting = false;
		f.isWaiting = function(){ return f.waiting; }

		return f;

	}
	
	//Timing
	this.pause = function(t,c){
		var a = false;
		if(t == 0) c();
		else a = setTimeout(c,t);
		return a;
	}
	
	this.pauseDelegate = function(t){
		var new_args = [];
		for(var i = 1; i < arguments.length; i++) new_args.push(arguments[i]);
		return function(){ Igloo.pause(t,function(){Igloo.delegate.apply(this,new_args)();})};
	}

	//Colours
	this.getRGB = function(str){
		if(str.substr(0,1) == "#"){
			if(str.length == 7){
				var a = str.substr(1);
				var a1 = parseInt(a.substr(0,2),16);
				var a2 = parseInt(a.substr(2,2),16);
				var a3 = parseInt(a.substr(4,2),16);
			}else if(str.length == 4){
				var a = str.substr(1);
				var a1 = parseInt(a.substr(0,1)+a.substr(0,1),16);
				var a2 = parseInt(a.substr(1,1)+a.substr(1,1),16);
				var a3 = parseInt(a.substr(2,1)+a.substr(2,1),16);
			}
		}else{

			var a = str.substr(str.indexOf("(")+1,str.length-str.indexOf("(")-2);
			var b = a.split(", ");
			var a1 = b[0];
			var a2 = b[1];
			var a3 = b[2];
		}
		return [a1,a2,a3];
	}
	
	
	
	//IID 20120206
	this.blendRGB = function(c1,c2,p){
		var _c1 = this.getRGB(c1);
		var _c2 = this.getRGB(c2);
		var _c3 = [
				   	Math.round(_c1[0]*(1-p) + _c2[0]*(p)),
					Math.round(_c1[1]*(1-p) + _c2[1]*(p)),
					Math.round(_c1[2]*(1-p) + _c2[2]*(p))
					];
		return _c3;
	}
	
	this.RGB2hex = function(r,g,b){
		if(typeof(r) == "object"){
			b = r[2];
			g = r[1];
			r = r[0];

		}
		var componentToHex = function(c){var hex = c.toString(16);return hex.length == 1 ? "0" + hex : hex;}
		return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
	}

	this.hexToRgb = function(hex) {
		// Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
		var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
		hex = hex.replace(shorthandRegex, function(m, r, g, b) {
			return r + r + g + g + b + b;
		});

		var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
		return result ? {
			r: parseInt(result[1], 16),
			g: parseInt(result[2], 16),
			b: parseInt(result[3], 16)
		} : null;
	}
	
	//Browsers
	
	//IID - V001, 20111217
	this.isiOS = function(){
		if(Igloo.defined(this.isiOS.saved)) return this.isiOS.saved;
		this.isiOS.saved = navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad)/);
		return this.isiOS.saved;
	}
	this.isIE = function(version){

		if(version) return Igloo.isIeVersion(version);

		//if(Igloo.defined(this.isiOS.saved)) return this.isiOS.saved;
		//this.isiOS.saved = navigator.userAgent.toLowerCase().match(/(msie)/);
		//return this.isiOS.saved;
	}
	this.isIeVersionSaved = {};
	this.isIeVersion = function(version_str){

		if(Igloo.defined(Igloo.isIeVersionSaved[version_str])) return Igloo.isIeVersionSaved[version_str];

		if(!Igloo.isIE()) return false;

		var version_formatted = Text.trim(version_str).replace(" ","");
		var versionNumber = 0;

		var op = "=";
		var c1 =  version_formatted.substr(0,1);
		if (c1 !== parseInt(c1, 10)) {
			if (version_formatted.substr(0, 1) == "<") op = c1;
			if (version_formatted.substr(0, 1) == ">") op = c1;
			var c2 = version_formatted.substr(0, 2)
			if (c2 == "<=") op = c2;
			if (c2 == ">=") op = c2;
			versionNumber = version_formatted.substr(op.length) * 1;
		}else{
			versionNumber = version_formatted * 1;
		}

		var iev = 10;
		var $html = $("html");
		if($html.hasClass("ie6")) iev = 6;
		if($html.hasClass("ie7")) iev = 7;
		if($html.hasClass("ie8")) iev = 8;
		if($html.hasClass("ie9")) iev = 9;

		var result = false;
		if(op == "<") result = iev < versionNumber;
		if(op == "<=") result = iev <= versionNumber;
		if(op == ">") result = iev > versionNumber;
		if(op == ">=") result = iev >= versionNumber;
		if(op == "=") result = iev == versionNumber;

		Igloo.isIeVersionSaved[version_str] = result;

		return result;
	}
	this.isMobile = function(){
		if(Igloo.defined(this.isMobile.saved)) return this.isMobile.saved;
		this.isMobile.saved = ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) );
		return this.isMobile.saved;
	}

	// added by luke
	this.cssSupport = function (property) {
		while (property.indexOf('-') !== -1) {
			var hyphen = property.indexOf('-');
			property = property.split('');

			if (hyphen !== -1) {
				if (hyphen === 0) {
					// Simply remove it
					property.splice(0, 1);
				} else {
					property.splice(hyphen, 1);
					var char = property.splice(hyphen, 1);
					property.splice(hyphen, 0, char[0].toUpperCase());
				}
			}

			property = property.join('');
		}

		var char = property.substr(0, 1);
		var vendorProperty = char.toUpperCase() + property.substr(1);

		var div = document.createElement('div');

		for (var style in div.style) {
			if (
				style === property ||
					style === 'webkit' + vendorProperty ||
					style === 'moz' + vendorProperty ||
					style === 'ms' + vendorProperty ||
					style === 'o' + vendorProperty
				) {
				return true;
			}
		}

		return false;
	};
	
	this.easing = function(f,x,start,end){
		if(!Igloo.defined(start)) start = 0; if(!Igloo.defined(end)) end = 1; return jQuery.easing[f]?jQuery.easing[f](x,x,0,1,1)*(end-start)+start:x*(end-start)+start;
	};

	this.hash = function(str, asString, seed) {
		asString = true;
		/*jshint bitwise:false */
		var i, l,
			hval = (seed === undefined) ? 0x811c9dc5 : seed;

		for (i = 0, l = str.length; i < l; i++) {
			hval ^= str.charCodeAt(i);
			hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
		}
		if( asString ){
			// Convert to 8 digit hex string
			return ("0000000" + (hval >>> 0).toString(16)).substr(-8);
		}
		return hval >>> 0;
	};

	this.fullscreen = function(f){
		if(!f) f = document;
		if (f.requestFullscreen) {
			f.requestFullscreen();
			return true;
		} else if (f.webkitRequestFullscreen) {
			f.webkitRequestFullscreen();
			return true;
		} else if (f.mozRequestFullScreen) {
			f.mozRequestFullScreen();
			return true;
		} else if (f.msRequestFullscreen) {
			f.msRequestFullscreen();
			return true;
		}else{
			return false;
		}
	}
	this.exitFullscreen = function(){
		if (document.exitFullscreen) {
			document.exitFullscreen();
		} else if (document.webkitExitFullscreen) {
			document.webkitExitFullscreen();
		} else if (document.mozCancelFullScreen) {
			document.mozCancelFullScreen();
		} else if (document.msExitFullscreen) {
			document.msExitFullscreen();
		}
	}

	this.isFullscreen = function(){
		return (
			document.fullscreenElement ||
			document.webkitFullscreenElement ||
			document.mozFullScreenElement ||
			document.msFullscreenElement
		)
	}
	this.htmlentities = function(str){
		return $("<div/>").text(str).html();
	}
	this.html_entity_decode = function(str){
		return $("<div/>").html(str).text();
	}
}}; Igloo.init();




//V001 - MAKE, EIP
var Text = {init:function(){
	
	//V101 - 09/02/2011, JHC
	this.basic_text = function(text,replace_char,extras){

		if(!replace_char) replace_char = "-";

		var extra_str = "";
		if(extras){
			if(typeof(extras) != "object") extras = [extras];
			for(var i in extras) extra_str += (extra_str ? ",\\" : "\\") + extras[i];
		}
	
		var s = "ç,æ,œ,á,é,í,ó,ú,à,è,ì,ò,ù,ä,ë,ï,ö,ü,ÿ,â,ê,î,ô,û,å,e,i,ø,u,'".split(",");
		var r = "c,ae,oe,a,e,i,o,u,a,e,i,o,u,a,e,i,o,u,y,a,e,i,o,u,a,e,i,o,u,".split(",");
		text = Text.str_replace(s, r, text);
		
		var re = new RegExp('([^a-zA-Z0-9'+extra_str+']+)','g');		
		text = Text.trim(text.replace(re,replace_char),replace_char).toLowerCase();
		
		return text;
	}
	
	//V101 - 09/02/2011, JHC
	//V102 - 13/02/2011, WFR - fixed \s problem (\\s required)
	this.trim = function(a,c){if(!c || c === " ") c = '\\s'; if(typeof(a)!="string"&&!a)a=""; return(a.toString()||"").replace(new RegExp('^('+c+'|\u00A0)+|('+c+'|\u00A0)+$','g'),"")}
	
	//V1001 - 09/02/2011, JHC
	this.str_replace = function(search, replace, subject, count) {
		var i = 0,
			j = 0,
			temp = '',
			repl = '',
			sl = 0,
			fl = 0,
			f = [].concat(search),
			r = [].concat(replace),
			s = subject,
			ra = r instanceof Array,
			sa = s instanceof Array;
		s = [].concat(s);
		if (count) {
			this.window[count] = 0;
		}
		for (i = 0, sl = s.length; i < sl; i++) {
			if (s[i] === '') {
				continue;
			}
			for (j = 0, fl = f.length; j < fl; j++) {
				temp = s[i] + '';
				repl = ra ? (r[j] !== undefined ? r[j] : '') : r[0];
				s[i] = (temp).split(f[j]).join(repl);
				if (count && s[i] !== temp) {
					this.window[count] += (temp.length - s[i].length) / f[j].length;
				}
			}
		}
		return sa ? s : s[0];
	}
	
	//V001 - 09/06/2011
	//Added for the waterfront
	this.to_number = function(str) {
		try{
			if(str == null) return 0;
			if(str == undefined) return 0;
			if(str == "null") return 0;
			if(str == "undefined") return 0;		
			if(str.substr(str.length-2,2) == "px") return str.substr(0,str.length-2)*1;
			if(str.substr(str.length-1,1) == "%") return str.substr(0,str.length-1)*1;			
			return str*1;
		}catch(err){
			return 0;			
		}
	}
	this.toNumber = this.to_number;
	
	this.leadingZero = function(n,z) {
		if(!Igloo.defined(z)) z = 2;
		for(var i = 0; i < z; i++){
			var _max = Math.pow(10,i);
			if(n < _max){
				var zeros = ''; for(var j = 0; j < z - i; j++) zeros += '0';
				return zeros+n;
			}
		}
		return n;
	}
	this.firstLetterIsVowel = function(str){
		return "aioue".indexOf( Text.decodeEntities(str).toLowerCase().replace(/[^a-z]/,"").substr(0,1) ) >= 0;
	}
	this.decodeEntities = (function() {
		// this prevents any overhead from creating the object each time
		var element = document.createElement('div');

		function decodeHTMLEntities (str) {
			if(str && typeof str === 'string') {
				// strip script/html tags
				str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
				str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
				element.innerHTML = str;
				str = element.textContent;
				element.textContent = '';
			}

			return str;
		}

		return decodeHTMLEntities;
	})();

	this.dotdotdotWords = function(str,chars){
		if(!str) return "";
		if(str.length<=chars) return str;

		var trimmedString = Text.trim(str.substr(0, chars-3));
		trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));
		return trimmedString + "...";

	};

	this.copyToClipboard = function(text,verbose) {
		var textArea = document.createElement("textarea");
		//http://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript

		textArea.style.position = 'fixed';
		textArea.style.top = 0;
		textArea.style.left = 0;
		textArea.style.width = '2em';
		textArea.style.height = '2em';
		textArea.style.padding = 0;
		textArea.style.border = 'none';
		textArea.style.outline = 'none';
		textArea.style.boxShadow = 'none';
		textArea.style.background = 'transparent';
		textArea.value = text;
		document.body.appendChild(textArea);
		textArea.select();

		try {
			var successful = document.execCommand('copy');
			var msg = successful ? 'successful' : 'unsuccessful';
			if(verbose) console.log('Copying text command was ' + msg);
		} catch (err) {
			if(verbose) console.log('Oops, unable to copy');
		}

		document.body.removeChild(textArea);
	}
	
}}; Text.init();
Igloo.regexCached = function(str,regex){
	if(!str || !regex) return false;

	var regex_str 	= String(regex);

	if(!this.regexCache) this.regexCache = {};
	if(!this.regexCache[regex_str]) this.regexCache[regex_str] = {};
	if(Igloo.defined(this.regexCache[regex_str][str])) return this.regexCache[regex_str][str];

	var result = str.match(regex);
	this.regexCache[regex_str][str] = result;
	return result;


}
Igloo.glob2regex = function (glob, opts) {
	if (glob == null) return null;

	var str = String(glob);


	//Check a cached result
	if(!this.glob2regexCache) this.glob2regexCache = {};
	if(!opts && Igloo.defined(this.glob2regexCache[str])) return this.glob2regexCache[str];

	// The regexp we are building, as a string.
	var reStr = "";

	// Whether we are matching so called "extended" globs (like bash) and should
	// support single character matching, matching ranges of characters, group
	// matching, etc.
	var extended = opts ? !!opts.extended : false;

	// If we are doing extended matching, this boolean is true when we are inside
	// a group (eg {*.html,*.js}), and false otherwise.
	var inGroup = false;

	var c;
	for (var i = 0, len = str.length; i < len; i++) {
	c = str[i];

	switch (c) {
	case "\\":
	case "/":
	case "$":
	case "^":
	case "+":
	case ".":
	//case "(":
	//case ")":
	case "=":
	case "!":
	//case "|":
	  reStr += "\\" + c;
	  break;

	case "?":
	  if (extended) {
		reStr += ".";
		break;
	  }

	case "[":
	case "]":
	  if (extended) {
		reStr += c;
		break;
	  }

	case "{":
	  if (extended) {
		inGroup = true;
		reStr += "(";
		break;
	  }

	case "}":
	  if (extended) {
		inGroup = false;
		reStr += ")";
		break;
	  }

	case ",":
	  if (inGroup) {
		reStr += "|";
		break;
	  }
	  reStr += "\\" + c;
	  break;

	case "*": //This has been edited to stop multiple paths being matched. ** now matches multiple paths
	  if(str.length > i && str[i+1] == "*"){ reStr += ".*"; i++}
	  else reStr += "[^\/]*";
	  break;

	default:
	  reStr += c;
	}
	}
	//Igloo.log(reStr);
	this.glob2regexCache[glob] = new RegExp("^" + reStr + "$");

	return this.glob2regexCache[glob];
};
Igloo.searchArrayGlob = function(arr, name, glob){
	
	var regex = Igloo.glob2regex(glob);
	for(var i = 0; i < arr.length; i++){

		var result = arr[i][name].match(regex);

		if(result) return arr[i];
	}
	return false;
	
}
if(!RegExp.escape){
	RegExp.escape = function(s) {
		return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	};
}


//V001 - IID
var Form = {init:function(){
	
	this.inlineSubmit = function(identifier,location,onComplete){
		
//		var d = document.getElementById(formID);
		var j = $(identifier);
		
		var data = {};
		j.find("input, textarea").each(function(i){
			var n = $(this).attr("name");												
			var v = $(this).val();
			if($(this).attr("type") == "checkbox" && !$(this).attr("checked")) v = "";
			data[n] = v;
		});

		$.ajax({  
		  type: "POST",  
		  url: location + "?ajax=1",  
		  data: data, 
		  success: onComplete
		});  

		return false;
	}
}}; Form.init();



////// Preloader ////////
//V1-01 - 13/01/2011
//V1-02 - 14/01/2011 - added optional timing functions
//V1-03 - 11/02/2011 - fixed reAdd no oncomplete bug
//V1-04 - 07/02/2011 - added avg_speed
//V1-05 - 27/09/2012 - added priorities and cancelLevels
var Preloader = {init:function() {
	var _this = this;
	
	this.speeds = [];
	
	this.images = [];
	this.state = "waiting";
	this.image_count	= 0;
	this.load_count		= 0;
	this.load_current	= 0;
	this.blank_image	= "/images/blank.gif"
	
	this.listeners 		= [];
	this.inlineTriggers = [];
	
	this.img = new Image();
	this.img.onload = function(){_this._onImageLoad();} //function wrapper otherwise onImageLoad wont be ready
	this.img.onerror = function(){_this._onImageError()} //function wrapper otherwise onImageLoad wont be ready
	
	this.add = function(src,onComplete,extras){
		//If it's already in the list, call the reAdd function instead.

		if(!src) Igloo.log("Preload error: cant load " + src);
		if(Igloo.isIn(this.images,"src",src) !== false) return this.reAdd(src,onComplete,extras);

		var id = this.images.length;


		//Get the full scr for later comparison
		var full_src = "";
		if(src.substr(0,4) == "http") full_src = src;
		else if(src.substr(0,1) == "/") full_src = document.location.protocol + "//" + document.location.hostname + ( document.location.port ? ":"+document.location.port : "" ) + src;
		else{
			var parts = document.location.pathname.split("/");
			parts.pop();
			full_src = document.location.protocol + "//" + parts.join("/") + "/" + src; //Ports could cause a problem here...
		}
		var onCompleteArray = onComplete ? [onComplete] : [];
		var onErrorArray = extras && extras.onError ? [extras.onError] : [];
		this.images.push({src:src,status:"waiting",full_src:full_src,onCompleteArray:onCompleteArray,onErrorArray:onErrorArray,errors:0,cancelLevel:0,priority:1});
		this.image_count ++;
		
		//Add extras
		if(extras && typeof(extras) == "object") {
			var image = this.images[this.images.length-1]; for (i in extras) image[i] = extras[i];
			if(extras['nocache']) image.full_src = this._addCache(image.full_src);
		}

		//for(var i in this.images) if(this.images[i].status != "loaded") Igloo.log(i + ": " + this.images[i].full_src + " " + this.images[i].status + " " + " " + this.images[i].cancelLevel  + " " + this.images[i].priority );

		this._start();
		
		return id;
	}
	
	this.remove = function(src,preventRestart){
		var id = Igloo.isIn(this.images,"src",src);
		if(!id) return false;
		var image = this.images[id];
		if(image.status == "loading"){
			this.cancel();
		}
		
		if(image.status == "loaded" || image.status == "failed") this.load_count --;
		else this._callOnComplete(image,false);
		
		this.image_count --;
		//Igloo.log("remove: " + image.src + "(" + id + ")")		
		this.images.splice(id,1);
		if(!preventRestart) this.restart();
		return true;
	}
	
	this.reAdd = function(src,onComplete,extras){ //Note that extras are not updated.
		
		var id = Igloo.isIn(this.images,"src",src);
		var image = this.images[id];
		if(image.status == "loaded" || image.status == "failed"){
			if(onComplete) onComplete.call(this,src,(image.status == "loaded"))
			this.callListeners(src,(image.status == "loaded"));
		}else{
			var priority = extras && extras.priority ? extras.priority : 1;
			if(image.priority > priority) image.priority = priority;
			if(onComplete) image.onCompleteArray.push(onComplete);	
			if(extras && extras.onError) image.onErrorArray.push(extras.onError);
		}
	}

	
	this.restart = function(){
		if(this.state != "loading") this._start();
	}
	
	this.cancel = function(){
		
		var id = Igloo.isIn(this.images,"status","loading");
		var image = this.images[id];
		
		if(this.state == "loading"){
			this.img.src = this.blank_image;
			this.state = "waiting";
		}
		
		if(id !== false && image) image.status = "waiting";
	}
	
	this.cancelSrc = function(src){
		var id = Igloo.isIn(this.images,"src",src);
		if(id === false) return false;
		var image = this.images[id];
		this.remove(image.src,true);
	}
	
	this.cancelAll = function(level){

		var c = 0;
		for(var i in this.images) if (this.images[i].cancelLevel >= level && (this.images[i].status == "waiting" || this.images[i].status == "loading")) c++;
		//Igloo.log("Cancel level: " + level +". " + c + " TO CANCEL" );
		//for(var i in this.images) Igloo.log(this.images[i].cancelLevel + " " + this.images[i].status + " " );	
		
		//Cancel every image equal or above the cancelLevel
		for(var i = 0; i < this.images.length; i++){
			var image = this.images[i];
			if(image.cancelLevel >= level && (image.status == "waiting" || image.status == "loading")){
				Igloo.log("Try remove of: " + i)
				if(this.remove(image.src,true)) i--;
			}
		}
		
		//Get the loading going again
		this._start();
	}
	
	this.check = function(src){
		var id = Igloo.isIn(this.images,"src",src);
		
		if(id === false) return false;
		
		var image = this.images[id];

		return image.status;
	}
	this.isLoaded = function(src){
		return this.check(src) == "loaded";
	}
	this.info = function(src){
		var id = Igloo.isIn(this.images,"src",src);
		if(id === false) id = Igloo.isIn(this.images,"full_src",src);
		
		if(id === false) return false;
		
		var image = this.images[id];

		return image;
	}
	
	//Sometimes we need to manage the loading from the cache into the browser too...
	this.inlineTrigger = function(onComplete, delay){
		var index = this.inlineTriggers.length
		if(!Igloo.defined(delay)) delay = 10;

		this.inlineTriggers[index] = {onComplete:onComplete,delay:delay};
		return " onload=\"Preloader.rit("+index+")\" ";
	}
	this.addInlineTrigger = function($img, onComplete, delay){ //Careful, needs to be added before the src... untested
		var index = this.inlineTriggers.length
		if(!Igloo.defined(delay)) delay = 10;

		this.inlineTriggers[index] = {onComplete:onComplete,delay:delay};
		$img.attr("onload","Preloader.rit("+index+")");
	}
	this.runInlineTrigger = function(index){

		var t = this.inlineTriggers[index];
		if(t){
			if(t && typeof(t.onComplete) == "function"){
				if(!t.delay)  	t.onComplete();
				else			setTimeout(t.onComplete, t.delay);
			}
			this.inlineTriggers[index] = null;
		}
	}
	this.rit = this.runInlineTrigger;
	
	//Private methods
	this._start = function(){
				
		if(this.state == "loading") 			return true;
		if(this.image_count <= this.load_count) return true;
		
	
		//Find next id to load
		//var cp = 0;
		//for(var i in this.images) if(this.images[i].status == "waiting"){ id = i; cp = this.images[i].priority; break; }
		//for(var ifor(var i in this.images) if(this.images[i].status == "waiting"){ id = i; cp = this.images[i].priority; break; }
		var priorityList = [];
		for(var i in this.images){
			if(this.images[i].status != "waiting") continue;
			var p = this.images[i].priority;
			if(!p) p = 1;
			if(!priorityList[p]) priorityList[p] = i;
		}
		
		/*Igloo.log("Waiting:")
		for(var i in this.images) if(this.images[i].status != "loaded") Igloo.log(this.images[i].src + " " + this.images[i].priority);
		Igloo.log("-------")*/
		
		for(var i in priorityList){
			var id = priorityList[i];
			if(id) break;
		}
		
		if(!id) return;

		var image = this.images[id];
		//Igloo.log("start " + image.src)

		
		this.state = "loading";

		image.status = "loading";		
		if(image.size) this._startTimer(image);
		this.img.src = image.full_src //This actually triggers the loading of the image
		//if(this.img.complete) this._onImageLoad(); //To check
	}
	
	this._onImageLoad = function(e) {
		var full_src = this.img.src;
	
		this.state = "waiting";

		var id = Igloo.isIn(this.images,"full_src",full_src);
		
		if(!id){
			Igloo.log("Preload error from image load: can't find "+ this.img.src);
			this._start();
			return false;
		}
		
		var image = this.images[id];
		//Igloo.log("loaded: " + image.src)		
		if(image.start_time) this._endTimer(image);
		
		image.status 	= "loaded";
		image.width 	= this.img.width;
		image.height 	= this.img.height;
		this.load_count++;
		
		
		this._callOnComplete(image,true)
		
		//Igloo.log("Completed " + id + " " + image.priority + " " + image.src)
		
		if(this.image_count > this.load_count) this._start();
	}
	
	this._callOnComplete = function(image,success){
		var c;
		for(var i in image.onCompleteArray) if(c = image.onCompleteArray[i]){
					
			var f = Igloo.defined(c['f']) ? c['f'] : c;
			var s = Igloo.defined(c['s']) ? c['s'] : false; //Whether we should run on an error / cancel
			if(s || success){
				image.onCompleteArray[i] = null;
				if(f) f(image.src,success,image);
			}
		}
		for(var i in image.onErrorArray) if(c = image.onErrorArray[i]){
			var f = Igloo.defined(c['f']) ? c['f'] : c;
			image.onErrorArray[i] = null;
			if(f && !success) Igloo.log("ON ERROR CALLED " + image.src)
			if(f && !success) f(image.src,success,image);
		}
		this.callListeners(image.src,success,image);
	}
	
	this._onImageError = function() {
		var full_src = this.img.src;
		
		this.state = "waiting";
		
		var id = Igloo.isIn(this.images,"full_src",full_src);
		
		if(!id){
			Igloo.log("Preload error on error: can't find "+ this.img.src);
			this._start();			
			return false;
		}
		
		var image = this.images[id];
		image.status = "waiting";
		image.errors ++;
		
		if(image.errors > 2){
			this.load_count++;
			image.status = "failed";
			this._callOnComplete(image,false);
		}
		
		
		
		this._start();
	}
	
	//Timer methods
	this.getSpeed = function(){
		var speed = 0;
		var weight = 0;
		
		if(this.speeds.length == 0) return false;
		
		for(var i = 0; i < this.speeds.length; i++) {
			weight += this.speeds[i].weight;
			speed += this.speeds[i].speed * this.speeds[i].weight;			
		}
		
		var avr = Math.round(speed / weight);
		
		/*var sd = 0;
		for(var i = 0; i < this.speeds.length; i++) {
			sd += (avr - this.speeds[i])*(avr - this.speeds[i]);
		}
		sd = Math.sqrt(sd/this.speeds.length);*/

		return  avr;
	}

	 this._startTimer = function(image){
		var d = new Date();
		image.start_time = d.getTime();
	 }
	 
	 this._endTimer = function(image){
		var d = new Date();
		image.end_time = d.getTime();
		image.total_time = image.end_time - image.start_time;
		image.speed = (image.size / 1024) / (image.total_time / 1000);
		
		//Check if we think it was cached
		if(image.speed > 1000 && !image.nocache ){
			image.was_cached = true;
		}else{
			image.was_cached = false;
		}
		
		var weight = 1;
		if(this.speeds.length > 0) weight *= 2; //First item seems to be crap
		weight += this.speeds.length/10; //The longer its been running, the better
		weight *= Math.log(image.size/1000);
		image.weight = weight;
	
		if(!image.was_cached){
			this.speeds.push({speed:image.speed,weight:image.weight });
		}

		image.avg_speed = this.getSpeed();

		//Igloo.log("T : " + image.total_time + ", " + image.size + "b, speed:" + image.speed + " W " + image.weight + " , " + image.avg_speed )
	 }
	 
	 this._addCache = function(src) {
		var new_src,
			d = new Date();
			
		//Check for ?
		if(src.indexOf("?") == -1){
			new_src = src + "?" + d.getTime();
		}else{
			new_src = src + "&" + d.getTime();
		}
		
		return new_src;
	}
	
	//Standard listener methods
	this.addListener = function(f){
		this.listeners.push(f);
	}
	
	this.removeListener = function(f){
		for(var i in this.listeners){
			if(this.listeners[i] == f){
				this.listeners.splice(i,1); 
				return;
			}
		}
	}
	
	this.callListeners = function(){
		for(var i in this.listeners){
			this.listeners[i].apply(this,arguments);
		}
	}
	
}}; Preloader.init();

var Preloader2 = {init:function() {
	var _this = this;

	this.images 		= [];
	//this.state 			= "waiting";

	this.image_count	= 0;
	this.loading_count	= 0;
	this.loaded_count	= 0;
	this.concurrent		= 2;

	this.id_count		= 0;
	this.lastId			= 0;

	this.speeds 		= [];

	this.blank_image	= "/images/blank.gif";

	this.listeners 		= [];
	this.inlineTriggers = [];

	//this.img = new Image();
	//this.img.onload = function(){_this._onImageLoad();} //function wrapper otherwise onImageLoad wont be ready
	//this.img.onerror = function(){_this._onImageError()} //function wrapper otherwise onImageLoad wont be ready

	this.add = function(options){



		if(typeof(options) == "string") options = {src: options};

		var src = options.src;

		if(!src){
			Igloo.log("Preload error: asked to load empty string.");
			return false;
		}

		var image, imageExists = this.getImageBySrc(src);
		if(imageExists){
			image = imageExists;
		}else{
			image = this.create(src);
		}


		//setup the item
		var id 				= this.id_count++;
		this.lastId			= id;
		var dfd 			= jQuery.Deferred();
		var promise 		= dfd.promise();
		var top 			= "top" in options ? options.top : false;
		var priority		= "priority" in options && options.priority ? options.priority*1 : 2; //Default to priority 2

		var tags			= options.tags?options.tags:(options.tag?[options.tag]:[]);
		//Igloo.log("Preload: " +priority +  (top ? "(top)" : "") + " " + src );

		var item = {
			id:			id,
			priority: 	priority,
			top:		top,
			dfd:		dfd,
			promise:	promise,
			tags:		tags
		}

		image.items.push(item);
		image.items.sort(function(a,b) {
			if (a.priority > b.priority) return 1;
			if (a.priority < b.priority) return -1;
			//Same prioirty
			if (a.top && !b.top) return -1;
			if (b.top && !a.top) return 1;
			//Default to ids
			if (a.id > b.id) return 1;
			if (a.id < b.id) return -1;
			return 0;
		});

		if(image.status == "cancelled") image.status = "new";

		image.loaded.then(function(e){
			dfd.resolve(e);
		},(e) => {
			dfd.reject(e);
		});


		if(imageExists){
			this._check();
		}else{
			//If it's a new one, don't actually run it right away as we might add multiples with different priorities.
			setTimeout(Igloo.delegate(this,function(){
				this._check();
			}),1);
		}

		return promise;
	}

	this.create = function(src){

		var dfd 			= jQuery.Deferred();
		var promise 		= dfd.promise();

		var id 				= this.image_count++;
		var cleanSrc 		= nav.cleanUrl(src);

		var details = {
			id:			id, //This is a little confusing as it's the first id.
			src:		cleanSrc,
			dfd:		dfd,
			loaded:		promise,
			status:		"new",
			attempts:	0,
			items:		[],
			startTime:	+new Date()
		}
		this.images.push(details);

		return details;
	}
	this.getLastId = function(){
		return this.lastId;
	}
	this.getImageById = function(id){
		return Igloo.searchArray(this.images,"id",id);
	}
	this.getImageByItemId = function(id){
		var match = false;
		for(var i = 0, ii = this.images.length; i < ii; i++){
			var image = this.images[i];
			for(var j = 0, jj = image.items.length; j < jj; j++){
				if(image.items[j].id === id){
					match = image;
					break;
				}
			}
			if(match) break;
		}
		return match;
	}
	this.getItemByItemId = function(id,image){
		if(!image) image = this.getImageByItemId(id);
		return Igloo.searchArray(image.items,"id",id);
	}
	this.getItemsByItemTag = function(tag){
		var items = [];
		for(var i = 0, ii = this.images.length; i < ii; i++){
			var image = this.images[i];

			for(var j = 0, jj = image.items.length; j < jj; j++){
				var item = image.items[j];
				if(Igloo.isIn(item.tags,tag) !== false) items.push(item);
			}
		}
		return items;
	}
	this.getImageBySrc = function(src){
		var cleanSrc = src ? nav.cleanUrl(src) : src;
		var image = Igloo.searchArray(this.images,"src",cleanSrc);
		return image;
	}

	this.cancel = function(id){
		//Igloo.log("Cancel: "+id);
		var image 	= this.getImageByItemId(id);

		if(!image) return false;

		var item	= this.getItemByItemId(id, image);
		if(!item) return false;

		if(image.status == "loaded"){
			//	Igloo.log("(completed already)")
			return true;
		}

		//Remove it (item still exists)
		image.items.splice(Igloo.isIn(image.items, "id", id),1);

		if(image.items.length == 0){
			if(image.status == "loading"){
				this.cancelLoading(image.id);
			}else{
				image.status = "cancelled";
			}
		}

		item.dfd.reject();

		setTimeout(Igloo.delegate(this,function(){this._check()}),0); //Timeout so it doesn't start them while we cancel
	}

	this.cancelTag = function(tag){
		var items = this.getItemsByItemTag(tag);
		for(var i in items){
			var item = items[i];
			this.cancel(item.id);
		}
	}

	this.cancelLoading = function(id){

		var image = this.getImageById(id);
		if(!image) return;

		var status = image.status;
		image.status = "cancelled";

		if(status === "loading"){
			this.loading_count--;
			this.abortLoading(image);
		}

	}

	this.pauseLoading = function(id){

		var image = this.getImageById(id);
		if(!image) return;

		var status = image.status;
		image.status = "new";
		if(status === "loading"){
			this.loading_count--;
			this.abortLoading(image);
		}
	}

	this.abortLoading = function(image){
		//This needs the statuses triggering afterwards
		image.jqXHR.abort();
	}

	/*this.cancelSrc = function(src){
	 var image = this.getImageBySrc(src);
	 this.cancel(image.id);
	 }*/


	this.checkSrc = function(src){
		return this.getStatus(src) == "loaded";
	}
	this.getStatus = function(src){
		var image = this.getImageBySrc(src);
		return image.status;
	}
	this.getDetails = function(src){
		return this.getImageBySrc(src);
	}


	this.inlineTrigger = function(onComplete, delay){
		var index = this.inlineTriggers.length
		if(!Igloo.defined(delay)) delay = 10;

		this.inlineTriggers[index] = {onComplete:onComplete,delay:delay};
		return " onload=\"Preloader2.rit("+index+")\" ";
	}
	this.addInlineTrigger = function($img, onComplete, delay){ //Careful, needs to be added before the src... untested
		var index = this.inlineTriggers.length
		if(!Igloo.defined(delay)) delay = 10;

		this.inlineTriggers[index] = {onComplete:onComplete,delay:delay};
		$img.attr("onload","Preloader2.rit("+index+")");
	}
	this.runInlineTrigger = function(index){

		var t = this.inlineTriggers[index];
		if(t){
			if(t && typeof(t.onComplete) == "function"){
				if(!t.delay)  	t.onComplete();
				else			setTimeout(t.onComplete, t.delay);
			}
			this.inlineTriggers[index] = null;
		}
	}
	this.rit = this.runInlineTrigger;

	//Private methods
	this._check = function(){
		if(this.image_count == this.loaded_count) return true;

		var loadingImages = Igloo.searchArray(this.images,"status","loading",true);
		for(var i in loadingImages){
			var image = loadingImages[i];
			if(image.items[0].priority == 1 && image.items[0].top){
				return;
			}
		}
		var newImages = Igloo.searchArray(this.images,"status","new",true);
		if(!newImages || newImages.length == 0) return true;
		newImages.sort(function(a,b) {
			if (a.items[0].priority > b.items[0].priority) return 1;
			if (a.items[0].priority < b.items[0].priority) return -1;
			//Same prioirty
			if (a.items[0].top && !b.items[0].top) return -1;
			if (b.items[0].top && !a.items[0].top) return 1;
			//Same everything
			if (a.items[0].id > b.items[0].id)    return 1;
			if (a.items[0].id < b.items[0].id)    return -1;
			return 0;
		});


		//If we've got a priority cancel everything else.
		var topItem = newImages[0].items[0];

		if(this.loading_count && topItem.priority == 1){ // && topItem.top === true
			for(var j = 0; j < this.images.length; j++){
				var img = this.images[j];
				if(img.status == "cancelled") continue;
				if(img.items[0].priority == 1 && !topItem.top) continue; //Don't do this for other priority 1s
				if(img.status == "loading") this.pauseLoading(img.id);
			}
		}

		var hasPriority = newImages[0].items[0].priority == 1;
		for(var i = 0; i < newImages.length; i++){
			var image = newImages[i];

			if(hasPriority && image.items[0].priority !== 1) break; //They're in order, so this will end once all pri 1s have been added
			//Allow to go over concurrent if it's priority 1
			if(this.loading_count < this.concurrent || hasPriority) {
				this.load(image.id);
				if(image.items[0].priority == 1 && image.items[0].top) break; //Don't load more
			}
		}
	}

	this.load = function(id){

		var image = this.getImageById(id);
		if(image && image.status === "new"){
			this.loading_count++;
			image.status = "loading";
			image.jqXHR = $.ajax({
				url:		image.src,
				method: 	"GET"
			});
			image.jqXHR.then(Igloo.delegate(this,function(e){
				image.mime = image.jqXHR.getResponseHeader('content-type');
				this.imageLoad(id);
			}),Igloo.delegate(this,Igloo.delegate(this,function(){

				if(image.status == "loading"){ //ie this was unexpected behaviour
					this.loading_count --;
					image.dfd.reject( new Error("Couldn't load ajax version of " + image.src) );
					this._check();
					image.status == "failed";
				}
			})));
		}else{
			if(!image) 	new Error("Image not found");
			else		image.dfd.reject(new Error("Image called load when not new"));
			this._check();
		}
	}

	this.imageLoad = function(id) {

		var image = this.getImageById(id)
		if(!image) throw new Error("shouldn't be called - no image for id: "+ id);
		if(image.status !== "loading") throw new Error("shouldn't be called - I'm still loading for: "+ id);

		var img = new Image();
		img.onload = Igloo.delegate(this,function(e) {
			this.loading_count--;
			this.loaded_count++;
			image.status = "loaded";
			image.width 	= img.width;
			image.height 	= img.height;
			image.ratio		= image.width / image.height;
			image.endTime	= +new Date();
			image.loadTime 	= image.endTime - image.startTime;
			image.dfd.resolve(image)
			this._check();
		});
		img.onerror = Igloo.delegate(this,function() {
			image.status = "failed";
			this.loading_count--;
			this.loaded_count++;
			image.dfd.reject(image);
			this._check();
		});
		img.src = image.src;

	};


}}; Preloader2.init();


//A class which gives as a function that takes t and returns acceleration, velocity and position. Or just position if requested
//Working are in James's igloo emails, with subject "accelerate position"
//t_0 is start point, t_1 is mid point (where acceleration swaps direction) and t_2 is end point.
var AcceleratePosition = {

	t:		null,
	x:		null,
	v:		null,
	a:		null,

	t_0:	null,
	t_1:	null,
	t_2:	null,

	x_0:	null,
	x_1:	null,
	x_2:	null,

	v_0:	null,
	v_1:	null,
	v_2:	null,

	a_0:	null,
	a_1:	null,
	a_2:	null,

	type:	null,

	reset_data:	function(){

	},

	fixed_acceleration : function(_x_0, _x_2, _v_0, _a){
		this.type = "fixed_acceleration";

		//Defaults
		if(!Igloo.defined(_a)) _a = 1;

		this.t_0 = 0;

		this.x_0 = _x_0;
		this.x_2 = _x_2;

		this.v_0 = _v_0;
		this.v_2 = 0;

		this.a_0 = _a * ( this.x_0 < this.x_2 ? 1 : -1 );
		this.a_1 = - this.a_0;
		this.a_2 = 0;

		this.t_1 = this.calculate_t_1();
		if(this.t_1 < 0) return this.fixed_acceleration(_x_0, _x_2, _v_0, -_a);

		this.t_2 = this.calculate_t_2();
		this.v_1 = this.calculate_v_1();
		this.x_1 = this.get_x(this.t_1);
		this.v_1 = this.get_x(this.t_1);

		//Closure
		var _this = this;
		var t_0 = 0;
		var t_1 = this.t_1;
		var t_2 = this.t_2;
		var x_0 = this.x_0;
		var x_1 = this.x_1;
		var x_2 = this.x_2;
		var v_0 = this.v_0;
		var v_1 = this.v_1;
		var v_2 = this.v_2;
		var a_0 = this.a_0;
		var a_1 = this.a_1;
		var a_2 = this.a_2;
		return function(t,full){
			var x = _this.get_x_closure(t, t_1, t_2, x_0, x_1, v_0, a_0);
			var v = _this.get_v_closure(t, t_1, t_2, x_0, x_1, v_0, a_0);
			var a = _this.get_a_closure(t, t_1, t_2, x_0, x_1, v_0, a_0);
			if(!full) 	return x;
			else		return {
				t 	: t,
				x	: x,
				v	: v,
				a	: a,
				t_0 : t_0,
				t_1 : t_1,
				t_2 : t_2,
				x_0 : x_0,
				x_1 : x_1,
				x_2 : x_2,
				v_0 : v_0,
				v_1 : v_1,
				v_2 : v_2,
				a_0 : a_0,
				a_1 : a_1,
				a_2 : a_2
			};
		}

	},


	calculate_t_1 : function(){
		var A = 1;
		var B = 2 / this.a_0 * this.v_0;
		var C = 1 / this.a_0 * ( this.x_0 - this.x_2 + this.v_0 * this.v_0 / (2 * this.a_0) - this.v_2 * this.v_2 / (2 * this.a_0) );

		var r = this.quadratic(A,B,C);

		return Math.max(r[0],r[1]);
	},

	calculate_t_2 : function(){
		return this.t_1 + ( this.v_0 - this.v_2 ) / this.a_0 + this.t_1
	},

	calculate_v_1 : function(){
		return this.v_0 + this.a_0 * this.t_1;
	},

	quadratic : function(a,b,c){
		var r = Math.sqrt(b*b - 4 * a * c);
		return [(- b + r ) / ( 2 * a),(- b - r ) / ( 2 * a)];
	},

	rounding : function(n){
		var acc 	= 5;
		var multi 	= Math.pow(10,acc);
		return Math.round(n*multi)/multi;
	},

	get_x : function(t){

		return this.get_x_closure( t, this.t_1, this.t_2, this.x_0, this.x_1, this.v_0, this.a_0 );

	},

	get_x_closure : function(t, t_1, t_2, x_0, x_1, v_0, a){

		if(t < 0) 		t = 0;
		if(t > t_2) 	t = t_2;

		if(t <= t_1){
			return this.rounding( x_0 + v_0 * t + a * t * t / 2 );
		}else{
			return this.rounding( x_1 + (v_0 + a * t_1) * (t - t_1) - a * (t - t_1) * (t - t_1) / 2 );
		}

	},

	get_v_closure : function(t, t_1, t_2, x_0, x_1, v_0, a){

		if(t < 0) 		t = 0;
		if(t > t_2) 	t = t_2;

		if(t <= t_1){
			return this.rounding( v_0 + a * t );
		}else{
			return this.rounding( v_0 + a * t_1 - a * (t - t_1) );
		}

	},

	get_a_closure : function(t, t_1, t_2, x_0, x_1, v_0, a){

		if(t < 0) 		t = 0;
		if(t > t_2) 	t = t_2;

		if(t <= t_1){
			return a;
		}else{
			return -a;
		}

	}


	//** Animation bits of this **//
	/*
	 moveTo : function(final_x, details){
	 if(!details.initial_x) 	details.initial_x 	= 0;
	 if(!details.interval) 	details.interval 	= 30;

	 //initial_x
	 //internval

	 }*/

};

//Options are
// func, time, interval
var SimpleInterval = function(options){

	var timer		= 0;
	var finish 		= options.time ? options.time : 1000;
	var interval	= options.interval ? options.interval : 25;
	var update		= options.func;
	var int;


	this.cancel = clear;

	var clear = function(){
		clearInterval(int);
	}
	var f = function(){
		timer = timer + interval;
		if(timer > finish) timer = finish;
		var x = timer / finish;
		update(x,{timer:timer, finish:finish});
		if(timer == finish) clear();
	}

	int = setInterval(f,interval);
}

//Options are
// func, time, interval
var SimpleInterval = function(options){

	var timer		= 0;
	var finish 		= options.time ? options.time : 1000;
	var interval	= options.interval ? options.interval : 25;
	var update		= options.func;
	var complete	= options.complete;
	var int;
	var thenFunction;
	var isCompelte	= false;

	var clear = function(success){
		if(isCompelte) return;
		clearInterval(int);
		isCompelte = true;
		if(complete) complete({success:success});
		if(thenFunction) thenFunction({success:success});
	}
	this.cancel = clear;
	var f = function(){
		timer = timer + interval;
		if(timer > finish) timer = finish;
		var x = timer / finish;
		update(x,{timer:timer, finish:finish});
		if(timer == finish) clear(true);
	}
	this.then = function(f){
		thenFunction = f;
	}


	int = setInterval(f,interval);
}


var AcceleratePositionToggle = function(settings){

	this.current_x = 			0;
	this.current_v = 			0;
	this.current_step =			0;
	this.current_interval =		false;
	this.current_end = 			0;
	this.current_start = 		0;
	this.current_details =		false;
	this.interval_time =		30;

	this.update_function =		false;

	this.status =				"off";
	this.a =					1;
	this.af =					null;

	this.active = 				false;

	this.setup = 			function(type,uf,x,a,onStart, onComplete){
		this.update_function = uf;
		this.type 	= type;
		if(Igloo.defined(x))	this.current_x = x;
		if(Igloo.defined(a))	this.a = a;
		this.onComplete = onComplete ? onComplete : null;
		this.onStart 	= onStart ? onStart : null;
		return this;
	};

	this.change =			function(n,a){


		var instant = false;
		if(Igloo.defined(a)){
			if(a === true) 	instant = true;
			else			this.a = a;
		}
		if(this.current_x === false) instant = true;
		if(n === this.current_x && this.current_v == 0) return this.complete();

		this.start(n,instant);
	};

	this.instant = function(n){
		this.change(n,true);
	};

	this.on =			function(instant){
		this.status = "on";
		this.start(1,instant);
	};

	this.off =		function(instant){
		this.status = "off";
		this.start(0,instant);
	};

	this.toggle =		function(){
		if(this.status == "on") return this.off();
		else					return this.on();
	};

	this.start =		function(end, instant){


		//Is the current motion interrupted?
		if(this.active){
			var ms			= +new Date();
			var r			= Math.min(1, (ms - this.start_ms) / this.interval_time);
			this.update( this.current_t + r * this.interval_time / 1000);
		}

		this.active = true;

		clearInterval(this.interval);

		if(instant)							this.af = function(){ return {t_2:0,x:end} };
		else if(this.type === "accelerate")	this.af = AcceleratePosition.fixed_acceleration(this.current_x, end, this.current_v, instant?99999999999:this.a);
		else								this.af = function(x){ return x; };

		this.current_step 		= 0;
		this.current_details	= this.af(0,true);
		this.current_end		= end;
		this.current_start		= this.current_x;

		if(this.onStart) 		this.onStart(this.current_x, {end:end});
		this.step();
		if(this.active)			this.interval			= setInterval(Igloo.delegate(this,this.step),this.interval_time);

	};

	this.step =		function(){

		//Igloo.log(this.current_t + " " + this.current_step + " " + this.interval_time);

		this.update( this.current_step * this.interval_time / 1000 );

		if(this.update_function) this.update_function(this.current_x, {start:this.current_start,end:this.current_end});


		if(typeof(this.current_details) == "object"){
			if(this.current_t >= this.current_details.t_2) this.complete();
		}else{
			if(this.current_t >= 1) this.complete();
		}
		this.current_step++;
	};

	this.update = function(t){
		this.start_ms			= +new Date();
		this.current_t 			= t;
		this.current_details 	= this.af(this.current_t,true);
		this.current_x 			= typeof(this.current_details) == "object" ? this.current_details.x : this.current_details;
		this.current_v 			= typeof(this.current_details) == "object" ? this.current_details.v : 0;
	};

	this.complete =	function( triggerComplete ){
		if(typeof (triggerComplete) == "undefined") triggerComplete = true;
		clearInterval(this.interval);
		this.current_v 		= 0;
		this.active			= false;
		if(this.onComplete) this.onComplete(this.current_x);
	}

	this.setup(settings.type?settings.type:"accelerate",settings.onChange,Igloo.defined(settings.x)?settings.x:0,settings.a?settings.a:0,settings.onStart,settings.onComplete);

	this.stop = function(){
		this.complete(false);
	};

	this.set = function(x){
		this.current_x = x;
	};

	this.destroy = function(){
		clearInterval(this.interval);
	}

}



// MULTIPLE ON COMPLETE CLASS
// V001 - IID - 20120210
// Example useage:
// var onComplete = MultipleOnComplete.create(function(){alert("all done")});
// doSomething(onComplete());
// doSomething2(onComplete());
function MultipleOnComplete(onComplete){
	this.isComplete = false;
	this.total 		= 0;
	this.count 		= 0;
	this.items 		= [];
	this.singles 	= [];	
	this.labels 	= [];
	this.onComplete = onComplete;
	MultipleOnComplete.instance = MultipleOnComplete.instance ? MultipleOnComplete.instance+1 : 1;			
	this.instance = MultipleOnComplete.instance;
}
MultipleOnComplete.prototype.add = function(label,singleOnComplete){
	
	if(typeof(label) == "function"){
		singleOnComplete	= label;
		label = "";
	}
	
	var index = this.total++;
	
	if(singleOnComplete) this.singles[index] = singleOnComplete;
	
	this.items[index] = false;
	if(label){
		this.labels[index] = label;
		Igloo.log("Add listener ("+this.instance+"/"+index+"): " + label )
	}
	
	//var f = Igloo.pauseDelegate(1,this,this.completed,index); 
	var f = Igloo.delegate(this,this.completed,index); 
	f.check = Igloo.delegate(this,this.checkIndividual,index);
	return f;
}
MultipleOnComplete.prototype.completed = function(i){
	if(this.items[i]) return false; //Already called
	else{
		this.count++;
		this.items[i] = true;
		if(this.labels[i]) 	Igloo.log("Completed listener ("+this.instance+"/"+i+"): " + this.labels[i] );
		if(this.singles[i]) this.singles[i]();
		Igloo.pauseDelegate(0,this,this.checkComplete)();
	}
}
MultipleOnComplete.prototype.checkComplete = function(){
	if(this.isComplete) return true;
	if(this.count == this.total){
		if(this.labels.length) 	Igloo.log("Completed multiple ("+this.instance+")");						
		this.onComplete();
		return this.isComplete = true;
	}
	return false;
}
MultipleOnComplete.prototype.checkIndividual = function(i){
	return this.items[i];
}
MultipleOnComplete.prototype.ff = function(_this,func,label){ //this submits the onComplete unless the function returns absolutely false
	var onComplete = this.add(label);
	var result 		= Igloo.delegate(_this,func)(onComplete);
	if(result !== false) onComplete();
	return result;
}
MultipleOnComplete.prototype.fff = function(_this,func,onComplete,label){ //this submits the onComplete unless the function returns absolutely false
	var result 		= Igloo.delegate(_this,func)(onComplete);
	if(result !== false) onComplete();
	return result;
}
//Factory method, creates a unique onComplete() creator.
MultipleOnComplete.create = function(onComplete){
	var instance = new MultipleOnComplete(onComplete);	
	var f		 = Igloo.delegate(instance,instance.add);
	f.f			 = Igloo.delegate(instance,instance.ff);
	f.ff		 = Igloo.delegate(instance,instance.fff);
	return f;
}


//-------------------- JQUERY COOKIES -------------------------//


// JavaScript Document
jQuery.cookie = function(name, value, options) {
    if (typeof value != 'undefined') { // name and value given, set cookie
        options = options || {};
        if (value === null) {
            value = '';
            options = $.extend({}, options); // clone object since it's unexpected behavior if the expired property were changed
            options.expires = -1;
        }
        var expires = '';
        if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
            var date;
            if (typeof options.expires == 'number') {
                date = new Date();
				date.setTime(date.getTime() + (options.expires*1000));
                //date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
            } else {
                date = options.expires;
            }
            expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
        }
        // NOTE Needed to parenthesize options.path and options.domain
        // in the following expressions, otherwise they evaluate to undefined
        // in the packed version for some reason...
        var path = options.path ? '; path=' + (options.path) : '; path=/';
        var domain = options.domain ? '; domain=' + (options.domain) : '';
        var secure = options.secure ? '; secure' : '';
        document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
    } else { // only name given, get cookie
        var cookieValue = null;
        if (document.cookie && document.cookie != '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = jQuery.trim(cookies[i]);
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) == (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
};

Igloo.getCookie = function(name){
	return jQuery.cookie(name);
};
Igloo.setCookie = function(name, value, options){
	var r = value;
	return r ? jQuery.cookie(name, r, options) : false;
};

function ReadMore(settings){
	this.className			= "ReadMore";
	this.setup(settings);
};

ReadMore.prototype.setup = function(settings){

	this.settings = settings;


	this.$wrapper 		= settings.$wrapper;
	this.$content 		= settings.$content;
	this.$text			= settings.$text;
	this.$readmore		= settings.$readmore;

	this.maxHeight		= settings.maxHeight ? settings.maxHeight : this.$wrapper.height();
	this.dynamicMaxHeight = (!settings.maxHeight);

	this.refresh();
	this.resizeDelegate = jstage.addListener("resize",Igloo.delegate(this,this.refresh));

	if(this.settings.inline) this.$readmore.remove();
	else this.setupDynamic();

}
ReadMore.prototype.refresh = function(){



	//This means it's not the first run so we'll need to return full content and do a basic check
	if(this.original){
		this.set(this.original);
	}

	if(this.$readmore) this.$readmore.hide();
	this.defaultHeight	= this.measure();
	if(this.dynamicMaxHeight) this.maxHeight = this.$wrapper.height();

	//Check if we already fit
	if(this.defaultHeight <= this.maxHeight) return true;

	//Otherwise let's go
	if(!this.original){
		this.original	= this.$text.html();
		this.parts		= this.split(this.original);
	}

	if(this.$readmore) this.$readmore.show();

	var from 	= 0;
	var to 		= this.parts.length - 2;

	var c = 0;
	do{
		var middle = Math.ceil((to+from)/2);
		var r = this.check(middle);


		if(r) 	from = middle;
		else	to	 = middle - 1;

		if(from == to) {
			break;
		}
	}while(c++ < 100);


	this.count = to;
	this.final = this.extract(to, true);
	this.set(this.final);
	this.setupDynamic();

	return true;


}
ReadMore.prototype.check = function(words){
	this.currentText = this.extract(words,true)
	this.set(this.currentText);
	var height = this.measure();
	return (height <= this.maxHeight);
}
ReadMore.prototype.measure = function(){

	var padding = Text.toNumber(this.$content.css("padding-bottom")) + Text.toNumber(this.$content.css("padding-top"));
	var height = this.$content.height() + padding;

	return height;
}
ReadMore.prototype.extract = function(words, fix){
	var str = this.parts.slice(0,words).join(" ");
	if(str.substr(-1,1).match(/[^a-zA-Z0-9]/)) str = str.substr(0,str.length-1); //While?

	if(this.settings.inline) str += this.$readmore.outerHtml();

	if(fix) str = $("<div/>").html(str).html();
	return str;
}
ReadMore.prototype.set = function(text){
	this.$text.html(text);
}
ReadMore.prototype.split = function(text){
	var openers = 0;
	var closers = 0;
	var inTag = false;
	var inSingleQuote = false;
	var inDoubleQuote = false;
	var c = false;
	var p = false;

	var parts = [];
	var s = 0;

	//Igloo.log(text)

	for (var i = 0; i < text.length; i++) {

		var found = false;

		p = c;
		c = text[i];

		if(inTag && c == "\"" && p != "\\" && !inSingleQuote) inDoubleQuote = !inDoubleQuote;
		if(inTag && c == "'" && p != "\\" && !inDoubleQuote) inSingleQuote = !inSingleQuote;


		if(inSingleQuote || inDoubleQuote) continue;


		if(c == "<"){
			openers++;
			inTag = true;
		}
		if(c == ">"){
			closers++;
			if(openers == closers){
				found = 2;
				inTag = false;
			}

		}
		if(!inTag && c == " ") found = 1;

		if(found || i == text.length-1){
			var skip = found == 1 ? 1 : 0;
			var word = text.substr(s,i-s+1-skip);
			if(word) parts.push(word);
			s = i + 1;
		}
	}


	return parts;


}
ReadMore.prototype.showAll = function(){
	this.$wrapper.css("height","auto");
	if(this.$readmore) this.$readmore.hide();
	this.set(this.original);
}
ReadMore.prototype.setupDynamic = function() {

	if (this.settings.dynamic) {

		if(this.settings.inline){

			this.$wrapper.find(".js-readmore").on("click", Igloo.$d(this, function () { ; //Todo remove hardcoded js-readmore
				this.showAll();
			}));
		}else{
			if (this.$readmore) this.$readmore.off("click").on("click", Igloo.$d(this, function () {
				this.showAll();
			}));
		}

	}
}
ReadMore.prototype.destroy = function(){
	if(this.resizeDelegate) jstage.removeListener("resize",this.resizeDelegate);
}
ReadMore.build = function(settings){

	var $wrapper 	= settings.$wrapper;
	var content 	= settings.content;
	var text 		= settings.text;
	var readmore	= settings.readmore;

	var rms = [];
	$wrapper.each(Igloo.$delegate(this,function($this){

		var s = Igloo.clone(settings);
		s.$wrapper = $this;
		if(content) s.$content = s.$wrapper.find(content);
		if(text) s.$text = s.$wrapper.find(text);
		if(readmore) s.$readmore = s.$wrapper.find(readmore);

		var rm = new ReadMore(s);
		rms.push(rm);
	}));


	return {
		instances: rms,
		refresh: function(){
			for (var i = 0; i < rms.length; i++) {
				var rm = rms[i];
				rm.refresh();
			}
		},
		destroy: function(){
			for (var i = 0; i < rms.length; i++) {
				var rm = rms[i];
				rm.destroy();
				// delete rm;
			}
			// delete rms;
		}
	};


	if(this.resizeDelegate) jstage.removeListener("resize",this.resizeDelegate);
};

/*!
 * numeral.js
 * version : 1.5.3
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
(function(){function a(a){this._value=a}function b(a,b,c,d){var e,f,g=Math.pow(10,b);return f=(c(a*g)/g).toFixed(b),d&&(e=new RegExp("0{1,"+d+"}$"),f=f.replace(e,"")),f}function c(a,b,c){var d;return d=b.indexOf("$")>-1?e(a,b,c):b.indexOf("%")>-1?f(a,b,c):b.indexOf(":")>-1?g(a,b):i(a._value,b,c)}function d(a,b){var c,d,e,f,g,i=b,j=["KB","MB","GB","TB","PB","EB","ZB","YB"],k=!1;if(b.indexOf(":")>-1)a._value=h(b);else if(b===q)a._value=0;else{for("."!==o[p].delimiters.decimal&&(b=b.replace(/\./g,"").replace(o[p].delimiters.decimal,".")),c=new RegExp("[^a-zA-Z]"+o[p].abbreviations.thousand+"(?:\\)|(\\"+o[p].currency.symbol+")?(?:\\))?)?$"),d=new RegExp("[^a-zA-Z]"+o[p].abbreviations.million+"(?:\\)|(\\"+o[p].currency.symbol+")?(?:\\))?)?$"),e=new RegExp("[^a-zA-Z]"+o[p].abbreviations.billion+"(?:\\)|(\\"+o[p].currency.symbol+")?(?:\\))?)?$"),f=new RegExp("[^a-zA-Z]"+o[p].abbreviations.trillion+"(?:\\)|(\\"+o[p].currency.symbol+")?(?:\\))?)?$"),g=0;g<=j.length&&!(k=b.indexOf(j[g])>-1?Math.pow(1024,g+1):!1);g++);a._value=(k?k:1)*(i.match(c)?Math.pow(10,3):1)*(i.match(d)?Math.pow(10,6):1)*(i.match(e)?Math.pow(10,9):1)*(i.match(f)?Math.pow(10,12):1)*(b.indexOf("%")>-1?.01:1)*((b.split("-").length+Math.min(b.split("(").length-1,b.split(")").length-1))%2?1:-1)*Number(b.replace(/[^0-9\.]+/g,"")),a._value=k?Math.ceil(a._value):a._value}return a._value}function e(a,b,c){var d,e,f=b.indexOf("$"),g=b.indexOf("("),h=b.indexOf("-"),j="";return b.indexOf(" $")>-1?(j=" ",b=b.replace(" $","")):b.indexOf("$ ")>-1?(j=" ",b=b.replace("$ ","")):b=b.replace("$",""),e=i(a._value,b,c),1>=f?e.indexOf("(")>-1||e.indexOf("-")>-1?(e=e.split(""),d=1,(g>f||h>f)&&(d=0),e.splice(d,0,o[p].currency.symbol+j),e=e.join("")):e=o[p].currency.symbol+j+e:e.indexOf(")")>-1?(e=e.split(""),e.splice(-1,0,j+o[p].currency.symbol),e=e.join("")):e=e+j+o[p].currency.symbol,e}function f(a,b,c){var d,e="",f=100*a._value;return b.indexOf(" %")>-1?(e=" ",b=b.replace(" %","")):b=b.replace("%",""),d=i(f,b,c),d.indexOf(")")>-1?(d=d.split(""),d.splice(-1,0,e+"%"),d=d.join("")):d=d+e+"%",d}function g(a){var b=Math.floor(a._value/60/60),c=Math.floor((a._value-60*b*60)/60),d=Math.round(a._value-60*b*60-60*c);return b+":"+(10>c?"0"+c:c)+":"+(10>d?"0"+d:d)}function h(a){var b=a.split(":"),c=0;return 3===b.length?(c+=60*Number(b[0])*60,c+=60*Number(b[1]),c+=Number(b[2])):2===b.length&&(c+=60*Number(b[0]),c+=Number(b[1])),Number(c)}function i(a,c,d){var e,f,g,h,i,j,k=!1,l=!1,m=!1,n="",r=!1,s=!1,t=!1,u=!1,v=!1,w="",x="",y=Math.abs(a),z=["B","KB","MB","GB","TB","PB","EB","ZB","YB"],A="",B=!1;if(0===a&&null!==q)return q;if(c.indexOf("(")>-1?(k=!0,c=c.slice(1,-1)):c.indexOf("+")>-1&&(l=!0,c=c.replace(/\+/g,"")),c.indexOf("a")>-1&&(r=c.indexOf("aK")>=0,s=c.indexOf("aM")>=0,t=c.indexOf("aB")>=0,u=c.indexOf("aT")>=0,v=r||s||t||u,c.indexOf(" a")>-1?(n=" ",c=c.replace(" a","")):c=c.replace("a",""),y>=Math.pow(10,12)&&!v||u?(n+=o[p].abbreviations.trillion,a/=Math.pow(10,12)):y<Math.pow(10,12)&&y>=Math.pow(10,9)&&!v||t?(n+=o[p].abbreviations.billion,a/=Math.pow(10,9)):y<Math.pow(10,9)&&y>=Math.pow(10,6)&&!v||s?(n+=o[p].abbreviations.million,a/=Math.pow(10,6)):(y<Math.pow(10,6)&&y>=Math.pow(10,3)&&!v||r)&&(n+=o[p].abbreviations.thousand,a/=Math.pow(10,3))),c.indexOf("b")>-1)for(c.indexOf(" b")>-1?(w=" ",c=c.replace(" b","")):c=c.replace("b",""),g=0;g<=z.length;g++)if(e=Math.pow(1024,g),f=Math.pow(1024,g+1),a>=e&&f>a){w+=z[g],e>0&&(a/=e);break}return c.indexOf("o")>-1&&(c.indexOf(" o")>-1?(x=" ",c=c.replace(" o","")):c=c.replace("o",""),x+=o[p].ordinal(a)),c.indexOf("[.]")>-1&&(m=!0,c=c.replace("[.]",".")),h=a.toString().split(".")[0],i=c.split(".")[1],j=c.indexOf(","),i?(i.indexOf("[")>-1?(i=i.replace("]",""),i=i.split("["),A=b(a,i[0].length+i[1].length,d,i[1].length)):A=b(a,i.length,d),h=A.split(".")[0],A=A.split(".")[1].length?o[p].delimiters.decimal+A.split(".")[1]:"",m&&0===Number(A.slice(1))&&(A="")):h=b(a,null,d),h.indexOf("-")>-1&&(h=h.slice(1),B=!0),j>-1&&(h=h.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1"+o[p].delimiters.thousands)),0===c.indexOf(".")&&(h=""),(k&&B?"(":"")+(!k&&B?"-":"")+(!B&&l?"+":"")+h+A+(x?x:"")+(n?n:"")+(w?w:"")+(k&&B?")":"")}function j(a,b){o[a]=b}function k(a){var b=a.toString().split(".");return b.length<2?1:Math.pow(10,b[1].length)}function l(){var a=Array.prototype.slice.call(arguments);return a.reduce(function(a,b){var c=k(a),d=k(b);return c>d?c:d},-1/0)}var m,n="1.5.3",o={},p="en",q=null,r="0,0",s="undefined"!=typeof module&&module.exports;m=function(b){return m.isNumeral(b)?b=b.value():0===b||"undefined"==typeof b?b=0:Number(b)||(b=m.fn.unformat(b)),new a(Number(b))},m.version=n,m.isNumeral=function(b){return b instanceof a},m.language=function(a,b){if(!a)return p;if(a&&!b){if(!o[a])throw new Error("Unknown language : "+a);p=a}return(b||!o[a])&&j(a,b),m},m.languageData=function(a){if(!a)return o[p];if(!o[a])throw new Error("Unknown language : "+a);return o[a]},m.language("en",{delimiters:{thousands:",",decimal:"."},abbreviations:{thousand:"k",million:"m",billion:"b",trillion:"t"},ordinal:function(a){var b=a%10;return 1===~~(a%100/10)?"th":1===b?"st":2===b?"nd":3===b?"rd":"th"},currency:{symbol:"$"}}),m.zeroFormat=function(a){q="string"==typeof a?a:null},m.defaultFormat=function(a){r="string"==typeof a?a:"0.0"},"function"!=typeof Array.prototype.reduce&&(Array.prototype.reduce=function(a,b){"use strict";if(null===this||"undefined"==typeof this)throw new TypeError("Array.prototype.reduce called on null or undefined");if("function"!=typeof a)throw new TypeError(a+" is not a function");var c,d,e=this.length>>>0,f=!1;for(1<arguments.length&&(d=b,f=!0),c=0;e>c;++c)this.hasOwnProperty(c)&&(f?d=a(d,this[c],c,this):(d=this[c],f=!0));if(!f)throw new TypeError("Reduce of empty array with no initial value");return d}),m.fn=a.prototype={clone:function(){return m(this)},format:function(a,b){return c(this,a?a:r,void 0!==b?b:Math.round)},unformat:function(a){return"[object Number]"===Object.prototype.toString.call(a)?a:d(this,a?a:r)},value:function(){return this._value},valueOf:function(){return this._value},set:function(a){return this._value=Number(a),this},add:function(a){function b(a,b){return a+c*b}var c=l.call(null,this._value,a);return this._value=[this._value,a].reduce(b,0)/c,this},subtract:function(a){function b(a,b){return a-c*b}var c=l.call(null,this._value,a);return this._value=[a].reduce(b,this._value*c)/c,this},multiply:function(a){function b(a,b){var c=l(a,b);return a*c*b*c/(c*c)}return this._value=[this._value,a].reduce(b,1),this},divide:function(a){function b(a,b){var c=l(a,b);return a*c/(b*c)}return this._value=[this._value,a].reduce(b),this},difference:function(a){return Math.abs(m(this._value).subtract(a).value())}},s&&(module.exports=m),"undefined"==typeof ender&&(this.numeral=m),"function"==typeof define&&define.amd&&define([],function(){return m})}).call(this);


/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 *
 * TERMS OF USE - jQuery Easing
 *
 * Open source under the BSD License.
 *
 * Copyright 2008 George McGinley Smith
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice, this list of
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list
 * of conditions and the following disclaimer in the documentation and/or other materials
 * provided with the distribution.
 *
 * Neither the name of the author nor the names of contributors may be used to endorse
 * or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 * GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 *
*/

// t: current time, b: begInnIng value, c: change In value, d: duration
$.easing.jswing = $.easing.swing;
$.extend($.easing,
	{
		def: 'easeOutQuad',
		swing: function (x, t, b, c, d) {
			//alert($.easing.default);
			return $.easing[$.easing.def](x, t, b, c, d);
		},
		easeInQuad: function (x, t, b, c, d) {
			return c*(t/=d)*t + b;
		},
		easeOutQuad: function (x, t, b, c, d) {
			return -c *(t/=d)*(t-2) + b;
		},
		easeInOutQuad: function (x, t, b, c, d) {
			if ((t/=d/2) < 1) return c/2*t*t + b;
			return -c/2 * ((--t)*(t-2) - 1) + b;
		},
		easeInCubic: function (x, t, b, c, d) {
			return c*(t/=d)*t*t + b;
		},
		easeOutCubic: function (x, t, b, c, d) {
			return c*((t=t/d-1)*t*t + 1) + b;
		},
		easeInOutCubic: function (x, t, b, c, d) {
			if ((t/=d/2) < 1) return c/2*t*t*t + b;
			return c/2*((t-=2)*t*t + 2) + b;
		},
		easeInQuart: function (x, t, b, c, d) {
			return c*(t/=d)*t*t*t + b;
		},
		easeOutQuart: function (x, t, b, c, d) {
			return -c * ((t=t/d-1)*t*t*t - 1) + b;
		},
		easeInOutQuart: function (x, t, b, c, d) {
			if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
			return -c/2 * ((t-=2)*t*t*t - 2) + b;
		},
		easeInQuint: function (x, t, b, c, d) {
			return c*(t/=d)*t*t*t*t + b;
		},
		easeOutQuint: function (x, t, b, c, d) {
			return c*((t=t/d-1)*t*t*t*t + 1) + b;
		},
		easeInOutQuint: function (x, t, b, c, d) {
			if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
			return c/2*((t-=2)*t*t*t*t + 2) + b;
		},
		easeInSine: function (x, t, b, c, d) {
			return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
		},
		easeOutSine: function (x, t, b, c, d) {
			return c * Math.sin(t/d * (Math.PI/2)) + b;
		},
		easeInOutSine: function (x, t, b, c, d) {
			return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
		},
		easeInExpo: function (x, t, b, c, d) {
			return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
		},
		easeOutExpo: function (x, t, b, c, d) {
			return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
		},
		easeInOutExpo: function (x, t, b, c, d) {
			if (t==0) return b;
			if (t==d) return b+c;
			if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
			return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
		},
		easeInCirc: function (x, t, b, c, d) {
			return -c * (Math.sqrt(1 - (t/=d)*t) - 1) + b;
		},
		easeOutCirc: function (x, t, b, c, d) {
			return c * Math.sqrt(1 - (t=t/d-1)*t) + b;
		},
		easeInOutCirc: function (x, t, b, c, d) {
			if ((t/=d/2) < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
			return c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
		},
		easeInElastic: function (x, t, b, c, d) {
			var s=1.70158;var p=0;var a=c;
			if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
			if (a < Math.abs(c)) { a=c; var s=p/4; }
			else var s = p/(2*Math.PI) * Math.asin (c/a);
			return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
		},
		easeOutElastic: function (x, t, b, c, d) {
			var s=1.70158;var p=0;var a=c;
			if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
			if (a < Math.abs(c)) { a=c; var s=p/4; }
			else var s = p/(2*Math.PI) * Math.asin (c/a);
			return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
		},
		easeInOutElastic: function (x, t, b, c, d) {
			var s=1.70158;var p=0;var a=c;
			if (t==0) return b;  if ((t/=d/2)==2) return b+c;  if (!p) p=d*(.3*1.5);
			if (a < Math.abs(c)) { a=c; var s=p/4; }
			else var s = p/(2*Math.PI) * Math.asin (c/a);
			if (t < 1) return -.5*(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
			return a*Math.pow(2,-10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )*.5 + c + b;
		},
		easeInBack: function (x, t, b, c, d, s) {
			if (s == undefined) s = 1.70158;
			return c*(t/=d)*t*((s+1)*t - s) + b;
		},
		easeOutBack: function (x, t, b, c, d, s) {
			if (s == undefined) s = 1.70158;
			return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
		},
		easeInOutBack: function (x, t, b, c, d, s) {
			if (s == undefined) s = 1.70158;
			if ((t/=d/2) < 1) return c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b;
			return c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
		},
		easeInBounce: function (x, t, b, c, d) {
			return c - $.easing.easeOutBounce (x, d-t, 0, c, d) + b;
		},
		easeOutBounce: function (x, t, b, c, d) {
			if ((t/=d) < (1/2.75)) {
				return c*(7.5625*t*t) + b;
			} else if (t < (2/2.75)) {
				return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
			} else if (t < (2.5/2.75)) {
				return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
			} else {
				return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
			}
		},
		easeInOutBounce: function (x, t, b, c, d) {
			if (t < d/2) return $.easing.easeInBounce (x, t*2, 0, c, d) * .5 + b;
			return $.easing.easeOutBounce (x, t*2-d, 0, c, d) * .5 + c*.5 + b;
		}
	});
